import type { TuiAdapter, TuiKind } from "./types.js";
import { ClaudeTuiAdapter } from "./claude.js";
import { OpenCodeTuiAdapter } from "./opencode.js";

export * from "./types.js";
export { ClaudeTuiAdapter } from "./claude.js";
export { OpenCodeTuiAdapter } from "./opencode.js";

/** Adapter factory. */
export function resolveTuiAdapter(kind: TuiKind = "claude-code"): TuiAdapter {
  switch (kind) {
    case "claude-code":
      return new ClaudeTuiAdapter();
    case "opencode":
      return new OpenCodeTuiAdapter();
    default:
      throw new Error(`Unknown TUI kind: ${kind as string}`);
  }
}
